import { useTranslation } from 'react-i18next';

import atIcon from '@/assets/icons/atIcon.svg';
import narrativeIcon from '@/assets/icons/narrativeIcon.svg';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';

interface ProfileTabsProps {
  children: React.ReactNode;
  onValueChange: (value: string) => void;
  value: string;
}

export function ProfileTabs({ children, onValueChange, value }: ProfileTabsProps) {
  const { t } = useTranslation();
  return (
    <Tabs className="flex min-h-0 flex-1 flex-col" onValueChange={onValueChange} value={value}>
      {/* Tabs */}
      <div className="px-3 pt-2 pb-2">
        <TabsList className="bg-elevated-subtle h-auto w-full min-w-0 justify-start gap-0 rounded-md p-0.5">
          <TabsTrigger
            className={`flex min-w-0 flex-1 cursor-pointer items-center justify-center gap-1 rounded-md border-0 px-2 py-1 font-['Inter'] text-[11px] leading-[160%] tracking-normal shadow-none transition-all duration-200 ease-out focus:outline-none focus-visible:ring-0 data-active:shadow-none ${
              value === 'narratives'
                ? 'bg-primary! text-primary-foreground! font-medium'
                : 'text-tertiary bg-elevated-subtle font-normal'
            }`}
            value="narratives"
          >
            <img
              alt={t('profile.tabs.narrativesAlt')}
              className={`h-3.5 w-3.5 ${value === 'narratives' ? 'icon-on-primary' : 'icon-themed'}`}
              src={narrativeIcon}
            />
            <span className="truncate">{t('profile.tabs.narratives')}</span>
          </TabsTrigger>
          <TabsTrigger
            className={`flex min-w-0 flex-1 cursor-pointer items-center justify-center gap-1 rounded-md border-0 px-2 py-1 font-['Inter'] text-[11px] leading-[160%] tracking-normal shadow-none transition-all duration-200 ease-out focus:outline-none focus-visible:ring-0 data-active:shadow-none ${
              value === 'draft-email'
                ? 'bg-primary! text-primary-foreground! font-medium'
                : 'text-tertiary bg-elevated-subtle font-normal'
            }`}
            value="draft-email"
          >
            <img
              alt={t('profile.tabs.draftEmailAlt')}
              className={`h-3 w-3 ${value === 'draft-email' ? 'icon-on-primary' : 'icon-themed'}`}
              src={atIcon}
            />
            <span className="truncate">{t('profile.tabs.draftEmail')}</span>
          </TabsTrigger>
        </TabsList>
      </div>

      {/* Main Content */}
      <div className="flex min-h-0 flex-1 flex-col overflow-hidden">{children}</div>
    </Tabs>
  );
}
